<template>
  <div>
    <div class="form" :class="{
      'form_w512': isFailed
    }">
      <div class="form__head">
        <div class="form__title form__title_white mb10">
          <span>Hallo. Wähle deine Stadt</span>
        </div>
      </div>

      <div v-if="!isFailed" class="form__content">
        <div class="form-item form-item_flex form-item_w100">
          <autocomplete-input
            :autocompleteValue="autocompleteValue"
            :placeholder="''"
            :fields="['address_component', 'geometry','place_id']"
            @fill="fill"
            class="mb24"
          />
        </div>

        <div class="form-item form-item_flex form-item_center">
          <button
            type="reset"
            class="btn btn_upper btn_w240"
            @click="done"
            :disabled="!isValid"
            :class="{
            btn_disabled: !isValid,
          }"
          >{{ $t("buttons.add") }}</button>
        </div>
      </div>
      <div v-else class="form__content">
        <div class="form-item mb24">
          <p
            class="form-item__text_center form-item__text_foz20 form-item__text_black form-item__text_bold form-item__text_lh32 mb6"
          >
            Unfortunately,
            we don’t provide services in this city... Yet ;)
          </p>
          <p
            class="form-item__text_center"
          >We are working to ensure that our service has appeared in every city!</p>
        </div>

        <div class="form-item form-item_flex form-item_center">
          <button class="btn btn_upper btn_w240" @click="tryToFindOfficeAgain">repeat</button>
        </div>
      </div>

      <div class="office-cat">
        <img :src="catImgUrl" alt />
      </div>
    </div>
  </div>
</template>

<script>
import autocompleteInput from "@/components/base/autocomplete/index";
import { mapActions } from "vuex";

export default {
  name: "office-modal",
  components: {
    autocompleteInput
  },
  data() {
    return {
      autocompleteValue: "",
      isSubmitted: false,
      isFailed: false,
      office_id: null
    };
  },
  computed: {
    isValid() {
      if (!this.office_id) {
        return false;
      }

      return true;
    },
    catImgUrl() {
      return this.isFailed
        ? require("@/assets/images/sadGeoCat.svg")
        : require("@/assets/images/getCat.svg");
    }
  },
  methods: {
    ...mapActions({
      checkCoordinates: "client/checkCoordinates"
    }),
    async fill(data) {
      const response = await this.checkCoordinates(data.place_id);
      this.office_id = response.data.office_id;

      if (!this.office_id) {
        this.isFailed = true;
        return;
      }
    },
    done() {
      this.$emit("done", this.office_id);
    },
    tryToFindOfficeAgain() {
      this.isFailed = false;
    }
  }
};
</script>